import { render } from "./Modal.vue?vue&type=template&id=054d6ace&scoped=true&ts=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=054d6ace&scoped=true&lang=css"

import exportComponent from "E:\\watersoftdesarrollo\\GitHub\\Sisflex_toma_pedidos_web\\Sistema\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054d6ace"]])

export default __exports__